import * as React from "react";

import { LoginUser } from "models/LoginUser";
import { ModalType, SelectConfig } from "models/ModalData";
import { CstmBtn, buttonTypes } from "app/components/common/Button";
import Translator from "app/components/common/Translator";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { Translate } from "infrastructure/mapping/Translate";
import { Translations } from "models/Translations";


export type TableColumn = {
    header: string,
    accessor: string
}

export interface TableFormData {
    header: string,
    formObject?: object,
}

export interface TableRow {
    dataObject: object,
    cells?: TableCell[],
}

export interface TableCell {
    cell: React.JSX.Element,
    sortVal: string | number
    name: string
}

interface Props {
    addFormAction?: Function;
    addFormData?: TableFormData;
    editFormAction?: Function;
    editFormData?: TableFormData
    addAction?: Function;
    editAction?: Function;
    deleteAction?: Function;
    editable: boolean;
    loginUser: LoginUser;
    tableData: TableRow[];
    columns: TableColumn[];
    translations: Translations;
    nonSelectables?: string[];
    hidden?: string[];
    selectConfigs?: SelectConfig[];
    optionals?: string[];
    defaultSort?: ColumnSort;
}

type State = {
    selectedTableRows: number[];
    columnSort?: ColumnSort;
    search: string;
}

export interface ColumnSort {
    columnId: string,
    sortType: number
}

const selectType = {
    header: 1,
    row: 2
}

export const sortType = {
    asc: 1,
    desc: 2
}

type basicDtaObject = {
    id: number,
    name: string
}

interface Cell<T> {
    id: string,
    type: T,
    value: string | number | basicDtaObject | object
}

export class Table extends React.Component<Props, State> {
    public readonly state: State = {
        selectedTableRows: [],
        search: "",
        columnSort: this.props.defaultSort ? { ...this.props.defaultSort } : undefined
    }

    addNew() {
        if (this.props.addFormAction) {
            this.props.addFormAction!({
                isActive: true,
                type: ModalType.FORM,
                header: this.props.addFormData!.header,
                formObject: this.props.addFormData!.formObject,
                callBack: this.props.addAction,
                nonSelectables: this.props.nonSelectables,
                hidden: this.props.hidden,
                selectConfigs: this.props.selectConfigs,
                optionals: this.props.optionals,
                template: this.props.addFormData!.formObject
            });
        } else {
            this.props.addAction!()
        }
    }

    delete() {
        if (this.state.selectedTableRows.length === 0) { }
        // error
        else {
            this.state.selectedTableRows.forEach(sr => this.props.deleteAction!(this.props.loginUser.token, sr))
        }
    }

    edit() {
        if (this.state.selectedTableRows.length === 0 || this.state.selectedTableRows.length > 1) {
            // should not be possible, button is disabled
        } else {
            const editId = this.state.selectedTableRows[0]; // should only be one so use first
            let fo = {};
            let id = 0;
            this.props.tableData.forEach(td => {
                for (const [key, value] of Object.entries(td.dataObject)) {
                    if (key === 'id' && value === editId) {
                        fo = td.dataObject;
                        id = value;
                    }
                }
            })
            if (fo) {
                if (this.props.editFormAction) {
                    this.props.editFormAction!({
                        isActive: true,
                        type: ModalType.FORM,
                        header: this.props.editFormData!.header,
                        formObject: fo,
                        callBack: (token: string, object: object) => this.props.editAction!(token, object),
                        nonSelectables: this.props.nonSelectables,
                        hidden: this.props.hidden,
                        selectConfigs: this.props.selectConfigs,
                        optionals: this.props.optionals,
                        template: this.props.addFormData?.formObject
                    });
                } else {
                    if (this.props.editAction) {
                        this.props.editAction(id)
                    }
                }
            }
            this.setState(prevState => {
                return { ...prevState, selectedTableRows: [] };
            });
        }

    }

    setRowSelected(event: React.ChangeEvent<HTMLInputElement>) {
        event.stopPropagation();
        const tableRowId = parseInt(event.currentTarget.id);
        if (tableRowId) {
            this.setState(prevState => {
                let newSelectedTableRows = [...prevState.selectedTableRows];
                if (newSelectedTableRows.find(sr => sr === tableRowId))
                    newSelectedTableRows = newSelectedTableRows.filter(sr => sr !== tableRowId)
                else
                    newSelectedTableRows.push(tableRowId);
                return { ...prevState, selectedTableRows: newSelectedTableRows };
            });
        } else {
            this.setState(prevState => {
                const td = this.props.tableData;
                let newSelectedTableRows: number[] = [];
                if (prevState.selectedTableRows.length !== td.length) {

                    for (let i = 0; i < td.length; i++) {
                        for (const [key, value] of Object.entries(td[i].dataObject)) {
                            if (key === 'id')
                                newSelectedTableRows.push(value as number)
                        }
                    }
                }
                return { ...prevState, selectedTableRows: newSelectedTableRows };

            });
        }
    }

    setColumnSort(event: React.MouseEvent<HTMLTableHeaderCellElement>) {
        event.preventDefault();
        const columnId = event.currentTarget.id;
        if (columnId) {
            this.setState(prevState => {
                let newColumnSort = prevState.columnSort;
                if (newColumnSort) {
                    if (newColumnSort.columnId === columnId) {
                        switch (newColumnSort.sortType) {
                            case sortType.asc:
                                newColumnSort = { ...newColumnSort, sortType: sortType.desc }
                                break;
                            case sortType.desc:
                                // the default column toggles between both directions, others fall back to the default
                                if (this.props.defaultSort && this.props.defaultSort.columnId === columnId)
                                    newColumnSort = { ...newColumnSort, sortType: sortType.asc }
                                else
                                    newColumnSort = this.props.defaultSort ? { ...this.props.defaultSort } : undefined
                                break;
                        }
                        return { columnSort: newColumnSort, selectedTableRows: prevState.selectedTableRows };
                    }
                }
                newColumnSort = {
                    columnId: columnId,
                    sortType: sortType.asc
                }
                return { columnSort: newColumnSort, selectedTableRows: prevState.selectedTableRows };
            });
        }
    }

    searchFilter(tr: TableRow) {
        if (!this.state.search || this.state.search.length < 3) {
            return true;
        }
        return this.searchInObject(tr.dataObject, this.state.search);
    }

    filterArchived(tr: TableRow) {
        for (const [key, value] of Object.entries(tr.dataObject)) {
            if (key === "archivedDate") {
                if (value)
                    return false;
                else 
                    return true; // only one archived date per object
            }   
        }
        return true;
    }

    searchInObject(obj: object, searchString: string): boolean {
        for (const value of Object.values(obj)) {
            if (value) {
                if (value instanceof Object && typeof value !== "symbol") {
                    if (this.searchInObject(value, searchString)) {
                        return true;
                    };
                } else {
                    var str = "";
                    if (value instanceof Array) {
                        (value as Array<object>).forEach(element => {
                            if (this.searchInObject(element, searchString))
                                return true;
                        });
                    } else {
                        if (typeof value === "number") {
                            str = value + "";
                        } else {
                            if (typeof value === "string") {
                                str = value;
                            } else {
                                if (typeof value === "symbol" || typeof value === "boolean") {
                                    str = "";
                                } else {
                                    str = (value.ToString() as string)
                                }
                            }
                        }
                    }
                    if (str.toUpperCase().includes(searchString.toUpperCase())) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    createTable() {
        return (
            <table className="c-table">
                <thead className="c-table__head">
                    <tr className="c-table__row">
                        {this.props.editable && this.addSelectColumn(selectType.header)}
                        {this.props.columns.filter(c => c.accessor !== 'id').map(hd => (
                            <th className="c-table__cell c-table__cell-header" key={hd.accessor} id={hd.accessor} onClick={(e) => this.setColumnSort(e)}>
                                <Translator text={hd.header} />
                                {this.getIconForSort(hd.accessor)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="c-table__body">
                    {this.state.columnSort ?
                        this.props.tableData.filter(td => this.searchFilter(td)).filter(td => this.filterArchived(td)).sort(this.sortRows.bind(this)).map((td, index) => {
                            return (
                                <tr className="c-table__row c-table__row--striped" key={index}>
                                    {this.createCells(td)}
                                </tr>
                            )
                        })
                        :
                        this.props.tableData.filter(td => this.searchFilter(td)).filter(td => this.filterArchived(td)).map((td, index) => {
                            return (
                                <tr className="c-table__row c-table__row--striped" key={index}>
                                    {this.createCells(td)}
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        );
    }

    getIconForSort(id: string) {
        if (this.state.columnSort && this.state.columnSort.columnId === id)
            switch (this.state.columnSort.sortType) {
                case sortType.asc:
                    return <span><FontAwesomeIcon icon={faChevronDown}></FontAwesomeIcon></span>
                case sortType.desc:
                    return <span><FontAwesomeIcon icon={faChevronUp}></FontAwesomeIcon></span>
            }
        return <></>
    }

    sortRows(aRow: TableRow, bRow: TableRow) {
        let aVal: object | string | number = {}
        let bVal: object | string | number = {}
        for (const [key, value] of Object.entries(aRow.dataObject)) {
            if (key === this.state.columnSort!.columnId) {
                if (aRow.cells?.find(c => c.name === this.state.columnSort!.columnId)) {
                    aVal = aRow.cells!.find(c => c.name === this.state.columnSort!.columnId)!.sortVal;
                }
                else {
                    if (value instanceof Object && !(value instanceof Date)) { // eval name if its a basicDtaObject
                        aVal = value.name;
                    } else
                        aVal = value;
                }
            }
        }
        for (const [key, value] of Object.entries(bRow.dataObject)) {
            if (key === this.state.columnSort!.columnId) {
                if (bRow.cells?.find(c => c.name === this.state.columnSort!.columnId)) {
                    bVal = bRow.cells!.find(c => c.name === this.state.columnSort!.columnId)!.sortVal;
                }
                else {
                    if (value instanceof Object && !(value instanceof Date)) {
                        bVal = value.name;
                    } else
                        bVal = value;
                }
            }
        }
        if (aVal < bVal) {
            if (this.state.columnSort!.sortType === sortType.asc)
                return -1;
            else
                return 1;
        }
        if (aVal > bVal) {
            if (this.state.columnSort!.sortType === sortType.asc)
                return 1;
            else
                return -1;
        }
        return 0;
    }

    createCells(row: TableRow): React.JSX.Element {
        let cells: Cell<string | number | React.JSX.Element>[] = [];
        for (const [key, value] of Object.entries(row.dataObject)) {
            if (row.cells && row.cells.find(r => r.name === key)) {
                cells.push({ id: key, type: "React.JSX.Element", value: row.cells.find(r => r.name === key)!.cell })
            } else {
                cells.push({ id: key, type: typeof value, value: value });
            }
        }
        return <>
            {this.props.editable && this.addSelectColumn(selectType.row, cells.find(c => c.id = "id")?.value as number)}
            {cells.filter(c => c.id !== 'id' && c.id !== 'archivedDate').map(c => {
                if (c.type === 'object') {
                    if (!(c.value instanceof Date)) {
                        let o = c.value as basicDtaObject;
                        return (
                            <td className="c-table__cell" key={c.id}>{o?.name}</td>
                        )
                    } else {
                        let o = c.value as Date;
                        return (
                            <td className="c-table__cell" key={c.id}>{o.toLocaleString()}</td>
                        )
                    }
                }
                if (c.type === 'React.JSX.Element') {
                    return <td className="c-table__cell" key={c.id}>{c.value as React.ReactNode}</td>;
                }
                return (
                    <td className="c-table__cell" key={c.id}>{c.value as React.ReactNode}</td>
                )
            })}
        </>
    }

    addSelectColumn(type: number, id?: number) {
        switch (type) {
            case (selectType.header):
                return (
                    <th className="c-table__cell c-table__cell-select">
                        <input type="checkbox" checked={this.isAllSelected()} onChange={(e) => this.setRowSelected(e)}></input>
                    </th>
                )
            case (selectType.row):
                return (
                    <td className="c-table__cell c-table__cell-select">
                        <input type="checkbox" id={id?.toString()} checked={this.isSelected(id!)} onChange={(e) => this.setRowSelected(e)}></input>
                    </td>
                )
        }
    }

    isAllSelected() {
        if (this.state.selectedTableRows?.length === this.props.tableData.length)
            return true;
        return false;
    }

    isSelected(id: number) {
        if (this.state.selectedTableRows?.find(sr => sr === id))
            return true;
        return false;
    }

    performSearch(e: React.ChangeEvent<HTMLInputElement>) {
        const newSearchVal = e.currentTarget.value;
        this.setState(prevState => {
            return { ...prevState, search: newSearchVal }
        })
    }

    render() {
        const hasTableData = this.props.tableData && this.props.tableData.filter(td => this.searchFilter(td)).filter(td => this.filterArchived(td)).length > 0;
        return (
            <>
                <div className="c-table__functions">
                    {/* read-only tables may still offer adding */}
                    {(this.props.addAction || this.props.addFormAction) &&
                        <CstmBtn onClick={() => this.addNew()} text="Add New" buttonType={buttonTypes.add} addClass="c-table__functions-buttons" />
                    }
                    {this.props.editable &&
                        <>
                            {hasTableData &&
                                <>
                                    {this.props.deleteAction &&
                                        <CstmBtn onClick={() => this.delete()} text="Delete" buttonType={buttonTypes.delete} addClass="c-table__functions-buttons" disabled={this.state.selectedTableRows.length <= 0} />
                                    }
                                    <CstmBtn onClick={() => this.edit()} text="Edit" buttonType={buttonTypes.edit} addClass="c-table__functions-buttons" disabled={this.state.selectedTableRows.length !== 1} />
                                </>
                            }
                        </>
                    }
                    <input type="text" className="c-table__table__functions-search" onChange={e => this.performSearch(e)} placeholder={Translate.text(this.props.translations, "Type to search")}></input>
                </div>
                { hasTableData && this.createTable()}
                { !hasTableData && 
                    <div className="c-table__empty">
                        <Translator text= "No data yet" />
                    </div>
                }
            </>
        )
    }
}